import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { ReportService } from 'src/app/repository/service/report.service';
import { AdvancedSearchService } from '../advanced-search/advanced-search.service';

@Component({
  selector: 'app-group-summary',
  templateUrl: './group-summary.component.html',
  styleUrls: ['./group-summary.component.scss']
})
export class GroupSummaryComponent implements OnInit, OnDestroy {
  public section_1:boolean = true;
  public section_2:boolean = false;
  public isFileList:boolean = true;
  public isCreateSummary:boolean = false;
  public isGroupList:boolean = false;
  public isGroupDetails:boolean = false;
  public searchText:string = "";
  
  public summaryTitle:string = "";
  public summaryObjective:string = "";
  
  public selectedFiles:string[]=[];
  public isCheckedSelectAll:boolean=false
  public selectedGroup:any = {};
  public selectedVIFiles:any[] = [];

  // public groupList:any[] = [];
  // public allGroupList:any[] = [];
  public viFiles:any[] = [];
  public allViFiles:any[] = [];
  private searchSub?: Subscription;
  public appliedSearch: any[] = [];
  public source: string = "individual_summaries";
  public isGeneratingSummary: boolean = false;

  constructor(public reportService: ReportService,
    public notifier: NotifierService,
    public aSearchservice:AdvancedSearchService ) { }

  ngOnDestroy(): void {
    this.selectedFiles = [];
    this.selectedVIFiles = [];
    this.changeSummaryState(1);
    this.summaryTitle = "";
    this.searchSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.reportService.studyId
    this.reportService.reportDetails;
    this.summaryObjective = JSON.parse(JSON.stringify(this.reportService.reportDetails['objective']));
    // console.log("this.reportService.isReport --->", this.reportService.isReport);
    // if(this.reportService.isReport){
    //   this.allViFiles = this.reportService.reportDetailFiles.filter( (file) => {
    //     return file.summary && file.summary !='' && (file['file_type'] == 'video' || file['file_type'] == 'Video' || file['file_type'] == 'audio' || file['file_type'] == 'Audio')
    //   })
    // }else if(this.reportService.isQual){
    //   this.allViFiles = this.reportService.reportDetails.interviews[0].files.filter( (file) => {
    //     return file.summary && file.summary !='' && (file['file_type'] == 'video' || file['file_type'] == 'Video' || file['file_type'] == 'audio' || file['file_type'] == 'Audio')
    //   })
    // }

    if(this.reportService.isQual){
      this.allViFiles = this.reportService.reportDetails.interviews[0].files.filter( (file) => {
        return file.summary && file.summary !='' && (file['file_type'] == 'video' || file['file_type'] == 'Video' || file['file_type'] == 'audio' || file['file_type'] == 'Audio')
      })
      this.viFiles = JSON.parse(JSON.stringify(this.allViFiles));
    }
    this.appliedSearch = JSON.parse(JSON.stringify(this.aSearchservice.appliedSearchCopy));
    this.getSummary({});
    // console.log("viFiles --->",this.viFiles)
    // this.setGroupList();
    // this.setGroupList();

    // Listen for advanced search apply
    this.searchSub = this.aSearchservice.applySearchEmitter.subscribe((payload: any[]) => {
      this.appliedSearch = payload || [];
      this.submitAdvanceSearch();
    });
  }

  // setGroupList(){
  //   // setTimeout(() => {
  //   //   this.reportService.allGroupList = (this.reportService.reportDetails["study_summary"] && this.reportService.reportDetails["study_summary"].groups && this.reportService.reportDetails["study_summary"].groups.length) ? this.reportService.reportDetails["study_summary"].groups : [];
  //   //   this.reportService.groupList = JSON.parse(JSON.stringify(this.reportService.allGroupList));
  //   // }, 0);
  // }

  changeSummaryState(index){
    if(index == 1){
      this.section_1 = true;
      this.section_2 = false;
      this.isFileList = true;
      this.isCreateSummary = false;
      this.getSummary({});
      this.checkAdvanceSearchVisibilty()
    }else{
      this.section_1 = false;
      this.section_2 = true;
      this.isGroupList = true;
      this.isGroupDetails = false;
      // this.reportService.getRepositoryDetail(this.reportService.detailsUUID);
      // this.closeAdvancedSearch();
      this.checkAdvanceSearchVisibilty()
      this.getSummary({});
      // this.onSearchChange(this.searchText, 'group');
      // this.setGroupList();
    }
  }

  onSummaryGenerate(){
    if (this.isGeneratingSummary) {
      return;
    }
    if (!this.summaryTitle || this.summaryTitle == "") {
      this.notifier.notify('error', 'Please enter summary title!');
      return;
    }
    if(!this.summaryObjective || this.summaryObjective == ""){
      this.notifier.notify('error', 'Please enter summary objective!');
      return;
    }
    if (this.source === 'individual_transcripts' && this.selectedFiles.length > 2) {
      this.notifier.notify('error', 'Group Summary can be generated of max 2 individual transcripts');
      return;
    }
    if (this.source === 'individual_summaries' && this.selectedFiles.length > 2) {
      this.notifier.notify('error', 'Group Summary can be generated of max 2 individual summaries');
      return;
    }
    this.isGeneratingSummary = true;
    let body = {"title":this.summaryTitle,"file_ids":this.selectedFiles,"objective":this.summaryObjective,"source":this.source}
    // console.log("body",body)   
    this.reportService.generateStudyAISummary(this.reportService.detailsUUID,body)
      .pipe(finalize(() => this.isGeneratingSummary = false))
      .subscribe(result =>{
      if(result['status'] == 1){
        this.reportService.getRepositoryDetail(this.reportService.detailsUUID);
        this.selectedFiles = [];
        this.summaryTitle = "";
        this.searchText = "";
        this.isCheckedSelectAll = false;
        this.notifier.notify('success','Summary generation is in progress');
        this.changeSummaryState(2);
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    });  
      
    // if (this.summaryTitle && this.summaryTitle != "") {
    // }else{
    //   this.notifier.notify('error', 'Please enter summary title!');
    // }
  }

  onSearchChange(value, type){
    this.searchText = value;
    // this.viFiles = this.allViFiles.filter((item) =>{return (item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase())) || (this.selectedFiles.includes(item.file_uuid))});
    if(type === 'file'){
      if (this.searchText && this.searchText != '') {
        this.viFiles = this.allViFiles.filter((item) =>{return (item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase())) || (this.selectedFiles.includes(item.file_uuid))});
      }else{
        this.viFiles = JSON.parse(JSON.stringify(this.allViFiles));
      }
    }else if(type === 'group'){
      if (this.searchText && this.searchText != '') {
        this.reportService.groupList = this.reportService.allGroupList.filter((item) => {return (item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase()))});
      }else{
        this.reportService.groupList = JSON.parse(JSON.stringify(this.reportService.allGroupList));
      }
    }

  }

  // selectAllFiles(isChecked){
  //   this.isCheckedSelectAll = isChecked
  //   if (this.isCheckedSelectAll) {
  //     this.selectedFiles = this.viFiles.map( file => file.file_uuid);
  //     this.selectedVIFiles = this.viFiles.filter( file => {return this.selectedFiles.includes(file.file_uuid)});
  //   }else{
  //     this.selectedFiles = [];
  //     this.selectedVIFiles = [];
  //   }
  // }

  // onCheckChanged(fileUUID){
  //   if (this.checkFileSelected(fileUUID)) {
  //     const index = this.selectedFiles.indexOf(fileUUID);
  //     if (index > -1) {
  //       this.selectedFiles.splice(index, 1); 
  //       this.isCheckedSelectAll = false;
  //     }
  //   }else{
  //     this.selectedFiles.push(fileUUID)
  //   }

  //   if(this.selectedFiles.length){
  //     this.selectedVIFiles = this.viFiles.filter( file => {return this.selectedFiles.includes(file.file_uuid)});
  //   }else{
  //     this.selectedVIFiles = [];
  //   }

  // }



   selectAllFiles(isChecked){
    this.isCheckedSelectAll = isChecked
    if (this.isCheckedSelectAll) {
      this.selectedFiles = this.viFiles.map( file => file.file_uuid);
      this.selectedVIFiles = this.viFiles.filter( file => {return this.selectedFiles.includes(file.file_uuid)});
    }else{
      this.selectedFiles = [];
      this.selectedVIFiles = [];
    }
  }

  onCheckChanged(fileUUID){
    if (this.checkFileSelected(fileUUID)) {
      const index = this.selectedFiles.indexOf(fileUUID);
      if (index > -1) {
        this.selectedFiles.splice(index, 1); 
        this.isCheckedSelectAll = false;
      }
    }else{
      this.selectedFiles.push(fileUUID)
    }

    if(this.selectedFiles.length){
      this.selectedVIFiles = this.viFiles.filter( file => {return this.selectedFiles.includes(file.file_uuid)});
    }else{
      this.selectedVIFiles = [];
    }

    // Automatically check/uncheck select all based on file selection
    if (this.selectedFiles.length === this.viFiles.length && this.viFiles.length > 0) {
      this.isCheckedSelectAll = true;
    } else {
      this.isCheckedSelectAll = false;
    }
  }

  checkFileSelected(fileUUID){
    return this.selectedFiles.includes(fileUUID) ? true :false
  }

  nextToGenerateSummary(){
    if(this.selectedFiles.length){
      this.section_1 = true;
      this.section_2 = false;
      this.isFileList = false;
      this.isCreateSummary = true;
      this.closeAdvancedSearch();
    }else{
      this.notifier.notify('error', 'Please select a file to generate summary!');
    }
  }

  backToSelectFiles(){
    this.section_1 = true;
    this.section_2 = false;
    this.isFileList = true;
    this.isCreateSummary = false;
    this.source = "individual_summaries";
    this.checkAdvanceSearchVisibilty();
  }

  viewSummary(group){
    let groupObj = {
      "name":group.name,
      "type":'group',
      "objective":group.objective,
      "summary":group.summary
    }
    // this.reportService.isGroupSummary = false;
    this.reportService.openViSummary(groupObj);
  }

  viewGroupDetails(group:any){
    this.section_1 = false;
    this.section_2 = true;
    this.isGroupList = false;
    this.isGroupDetails = true;
    this.selectedGroup = group;
    }

  pinGroup(group_uuid){
    
    let group = this.reportService.groupList.find(item => { return item.group_uuid === group_uuid});
    group.pin = true;

  
    this.reportService.pinGroupSummary(group_uuid).subscribe(result =>{
      if(result['status'] == 1){
        this.reportService.getRepositoryDetail(this.reportService.detailsUUID);
        this.notifier.notify('success','Summary pinned successfully');
        // this.setGroupList();        
        // this.changeSummaryState(2);
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    }); 
  }
  // unPinGroup(index){
  //   this.setGroupList()
  // }

  deleteGroup(group_uuid){
    let index = this.reportService.groupList.findIndex(item => item.group_uuid === group_uuid);
    this.reportService.deleteGroupSummary(group_uuid).subscribe(result =>{
      if(result['status'] == 1){
        this.reportService.groupList.splice(index, 1);
        this.reportService.getRepositoryDetail(this.reportService.detailsUUID);
        this.notifier.notify('success','Group deleted successfully');
        // this.changeSummaryState(2);
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    }); 
  }

  viewGroupFiles(group){
    if (group.showFiles) {
     this.reportService.reportDetails['study_summary'].groups.forEach((item) => {item.showFiles = false;});
    }else{
      this.reportService.reportDetails['study_summary'].groups.forEach((item) => {
        item.showFiles = false;
        if (item.group_uuid === group.group_uuid) {
          item.showFiles = true;
        }
    });
    }
  }

  openAdvancedSearch(){
    this.aSearchservice.openSearch();
  }

  closeAdvancedSearch(){
    this.aSearchservice.closeSearch();
  }

  submitAdvanceSearch(){
    // console.log("Applied Search:",this.appliedSearch);
    let body = {}
    if(this.appliedSearch && this.appliedSearch.length > 0){
      body["advance_search"] = this.appliedSearch;
    }
    this.getSummary(body);
  }

  closeTab(){
    this.reportService.closeGroupSummary();
    this.aSearchservice.closeSearch();
  }

  getSummary(body){
    this.reportService.studyId
    if(Object.keys(this.appliedSearch).length > 0){
      body['advance_search'] = this.appliedSearch; 
    }
    this.reportService.getStudySummary(this.reportService.studyId, body).subscribe(result =>{
      if(result['status'] != 1){
        this.notifier.notify("error","Something went wrong!")
        return;
      }
      this.allViFiles = result['data'];
      // this.allViFiles = [];
      this.viFiles = JSON.parse(JSON.stringify(this.allViFiles));
      this.reportService.allGroupList = result["study_summary"] && result["study_summary"].groups && result["study_summary"].groups.length ? result["study_summary"].groups : [];
      this.reportService.groupList = JSON.parse(JSON.stringify(this.reportService.allGroupList));
      // this.reportService.groupList = [];
      if (this.searchText && this.searchText != '' && this.viFiles && this.viFiles.length > 0) {
        if(this.section_1){
          this.onSearchChange(this.searchText, 'file');
        }else if(this.section_2){
          this.onSearchChange(this.searchText, 'group');
        }
        
      }
    });
  }
  downloadGroup(group){
    let body = {
      "uuid": group.group_uuid,
      "type": "group",
      "file_type": "pdf"
    };
    // console.log("Downloading group with UUID:", body);
    this.reportService.downloadGroupSummary(body).subscribe(result =>{
      if(result['status'] == 1){
        let Ahref: HTMLElement = document.getElementById("downloadFIleURLStudy");
        this.reportService.ahref = Ahref;
        this.reportService.fileName = group['name'];
        this.reportService.fileType = 'pdf';
        if(!result['url'] || result['url'] === ''){
          this.notifier.notify("error","Download URL not available!");
          return;
        }
        this.reportService.downloadFileOfType(result['url'],'pdf');
        // this.notifier.notify('success','Group downloaded successfully');
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    }); 
  }

  // DownloadFileFromStudyPage(group,type?:string)
  // {
  //   let Ahref: HTMLElement = document.getElementById("downloadFIleURLStudy");
  //   this.reportService.ahref = Ahref;
  //   this.reportService.fileName = group['name'];
  //   this.reportService.fileType = 'pdf';
  //   // this.reportService.downloadRequestFromService(type);
  //   if (type === 'pdf' || type === 'word') {
  //     this.reportService.downloadICVTranscript(type);
  //   }else{
  //     this.reportService.downloadRequestFromService(type);
  //   }
  // }

  checkAdvanceSearchVisibilty() {
    if (this.appliedSearch && Object.keys(this.appliedSearch).length > 0 && this.section_1 && this.isFileList) {
      this.aSearchservice.isAdvancedSearchOpen = true;
    }else{
      this.aSearchservice.isAdvancedSearchOpen = false;
    }
    return this.aSearchservice.isAdvancedSearchOpen;
  }


}
